import DesktopSettings from '../desktop';

const TabletSettings = () => <DesktopSettings />;

export default TabletSettings;
